import { render, staticRenderFns } from "./UserDelete.vue?vue&type=template&id=6bed3c0a&"
import script from "./UserDelete.vue?vue&type=script&lang=js&"
export * from "./UserDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports